// @core/api/endpoints/tag/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { BatchGetEntityTags } from './batch_get_entity_tags';
import { BulkTagEntities } from './bulk_tag_entities';
import { BulkUntagEntities } from './bulk_untag_entities';
import { CreateTag } from './create_tag';
import { DeleteTag } from './delete_tag';
import { GetTag } from './get_tag';
import { ListEntityTags } from './list_entity_tags';
import { ListTaggedEntities } from './list_tagged_entities';
import { ListTags } from './list_tags';
import { SearchTags } from './search_tags';
import { TagEntity } from './tag_entity';
import { UntagEntity } from './untag_entity';
import { UpdateTag } from './update_tag';

// Re-export individual endpoints
export {
  BatchGetEntityTags,
  BulkTagEntities,
  BulkUntagEntities,
  CreateTag,
  DeleteTag,
  GetTag,
  ListEntityTags,
  ListTaggedEntities,
  ListTags,
  SearchTags,
  TagEntity,
  UntagEntity,
  UpdateTag,
};

// Namespace export for convenient usage
export const tagApi = {
  BatchGetEntityTags,
  BulkTagEntities,
  BulkUntagEntities,
  CreateTag,
  DeleteTag,
  GetTag,
  ListEntityTags,
  ListTaggedEntities,
  ListTags,
  SearchTags,
  TagEntity,
  UntagEntity,
  UpdateTag,
};
